import { Spinner } from "@/components/common/Spinner";

export const LoadingLayer = () => {
  return (
    <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
      <Spinner />
    </div>
  );
};
